const defaultTheme = require('tailwindcss/defaultTheme')

const stencilBreakpoints = {
  ...defaultTheme.screens,
  sm: '300px',
  mob: '480px',
  1192: '1192px',
}

module.exports = stencilBreakpoints
